import React from 'react';
import styled, { css } from 'styled-components';
import { brand, darkgrey, divider, white } from 'styles/Colors';
import { ReactComponent as SwitchIcon } from 'components/icons/switch.svg';
import { ReactComponent as ClearIcon } from 'components/icons/clear.svg';
import { ListSubheader } from '@mui/material';

export const EditInputsContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
`;

export const TeamSelectContainer = styled.div`
  display: flex;
  gap: 20px;
`;

export const TeamSelectorWrapper = styled.div<{ disabled?: boolean }>`
  position: relative;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
`;

export const StyledClearIcon = styled((props) => <ClearIcon {...props} />)`
  z-index: 10;
  cursor: pointer;
  position: absolute;
  right: 13px;
  top: 30%;
`;

export const SmallTitle = styled.h3<{ margin: string }>`
  font-family: Lato;
  font-style: normal;
  font-weight: 700;
  font-size: 15px;
  margin: ${(props) => props.margin};
`;

export const StyledSwitchIcon = styled((props) => <SwitchIcon {...props} />)`
  width: 32px;
  height: 32px;
  padding: 8px;
  margin-top: 15px;
  background: ${divider};
  cursor: pointer;
  opacity: 1;

  ${(props) =>
    props.disabled &&
    css`
      cursor: default;
      opacity: 0.5;
    `}
`;

export const TeamsContainer = styled.div`
  height: 513px;

  .MuiInputLabel-root.Mui-focused {
    color: ${brand};
  }
`;

export const EditWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 10px;
`;

// TODO: export to umpire search styles
export const StyledListSubheader = styled((props) => <ListSubheader {...props} />)`
  &&& {
    color: ${darkgrey};
    font-feature-settings: 'liga' off;
    font-family: Lato;
    font-size: 11px;
    font-style: normal;
    font-weight: 700;
    line-height: 15.4px;
    padding: 8px;
    background-color: ${white};
    position: absolute;
    top: 0;
    width: calc(100% - 16px);
  }
`;

export const TeamTitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

export const EditTeams = styled.div`
  color: var(--Grayscale-textElementGrey, #414141);
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
`;

export const TeamsDivider = styled.span`
  display: block;
  width: 1px;
  height: 22px;
  background-color: #e0e0e0;
  margin: 0 12px;
`;

export const TeamWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  position: relative;
`;
